<ng-container *transloco="let t; read: 'layout.help'">
  <button mat-icon-button [disableRipple]="true" [matMenuTriggerFor]="supportMenu" aria-label="Example icon-button with a menu">
    <mat-icon [color]="color">contact_support</mat-icon>
  </button>
  <mat-menu #supportMenu="matMenu">
    <button mat-menu-item (click)="openDocumentation()">
      <span class="label">{{ t('help') }}</span>
    </button>
    <a mat-menu-item [routerLink]="['support/contact']">
      <span class="label">{{ t('contact') }}</span>
    </a>
  </mat-menu>
</ng-container>
